import React from 'react';
import isEqual from 'underscore/modules/isEqual';
import { debounce } from 'debounce';
import { convertNDimTo2DimPolylines, decodeNDim } from '../../../../../utils/at_map_helpers';
import { createElevChart } from '../../../../../utils/elev/elev_chart';
import { processElevations, processGroupedSegments, getGroupedSegments } from '../../../../../utils/elev/elev_pane_helpers';
import { requestElevations } from '../../../../../utils/requests/elevation_requests';

const createReactClass = require('create-react-class');

// TODO Debounce temporarily increased from 1000 to deload DEM server
const ELEVATION_REQUEST_DEBOUNCE_MS = 2000;

const FullscreenMapElevationPane = createReactClass({
  componentDidMount() {
    this._isMounted = true;
    this.pointByPointSegmented = null;
    this.totalDistance = null;
    this.colorsSegmented = null;
    this.segments = null;
    this.hasExistingPolylineElevations = false;
    this.createElevationGraph();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('orientationchange', this.handleResize);
    this.debouncedRequestElevationData = debounce((segments, colorsSegmented) => {
      const encodedPolylines = segments.map(seg => seg.polyline.pointsData);
      this.requestElevationData(encodedPolylines, colorsSegmented[0]);
    }, ELEVATION_REQUEST_DEBOUNCE_MS);
  },
  componentDidUpdate() {
    this.createElevationGraph();
  },
  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('orientationchange', this.handleResize);
  },
  handleResize() {
    this.redrawElevationGraph();
  },
  redrawElevationGraph() {
    if (!this.pointByPointSegmented) {
      return;
    }
    this.drawElevationGraph(this.pointByPointSegmented, this.colorsSegmented, this.totalDistance);
  },
  drawElevationGraph(pointByPointSegmented, colorsSegmented, totalDistance) {
    if (!this._isMounted) {
      return;
    }
    this.pointByPointSegmented = pointByPointSegmented;
    this.colorsSegmented = colorsSegmented;
    this.totalDistance = totalDistance;
    const { containerDivOverride, displayMetric, elevationConfig, handleMouseOver, height, showStatsGroup, width, languageRegionCode } = this.props;
    const dom = containerDivOverride ? document.getElementById(containerDivOverride) : this.refs.elevChart;
    createElevChart({
      colorsSegmented,
      displayMetric,
      dom,
      elevationConfig,
      handleMouseOver,
      height,
      pointByPointSegmented,
      showStatsGroup,
      totalDistance,
      width,
      languageRegionCode
    });
  },
  createElevationGraph() {
    const groupedSegments = getGroupedSegments(this.props.map);
    const segments = groupedSegments.map(group => group.segments).flat();
    let colorsSegmented = groupedSegments.map(group => group.color);

    // Used to override color for things like showing the verified-route in a different color for admins
    if (this.props.colorOverride) {
      colorsSegmented = colorsSegmented.map(() => this.props.colorOverride);
    }

    // Don't bother making any elevation requests or related if segment data hasn't changed
    if (isEqual(this.segments, segments)) {
      if (!isEqual(this.colorsSegmented, colorsSegmented)) {
        // Redraw elevation graph with new segment colors if colors changed in trail planner
        this.colorsSegmented = colorsSegmented;
        this.redrawElevationGraph();
      }
      return;
    }
    this.segments = segments;

    // Special handling for no segments
    if (segments.length < 1) {
      this.drawElevationGraph([], 0, []);
      if (this.props.handleElevationGainChanged) {
        this.props.handleElevationGainChanged(0);
      }
      return;
    }

    // Special handling for in-progress lifeline
    if (
      !this.hasExistingPolylineElevations &&
      this.props.lifeline &&
      this.props.lifeline.currentPolylines.length > 0 &&
      decodeNDim(this.props.lifeline.currentPolylines[0]).length > 1
    ) {
      const encodedPolylines = convertNDimTo2DimPolylines(this.props.lifeline.currentPolylines);
      this.requestElevationData(encodedPolylines, colorsSegmented[0]).then(() => {
        this.hasExistingPolylineElevations = true;
      });
      return;
    }

    // Special handling for live-updating elevation data while in trail-planner mode
    if (this.props.getElevationData) {
      this.debouncedRequestElevationData(segments, colorsSegmented);
      return;
    }

    // Calculate elevPointByPoint and totalDistance
    const { pointByPointSegmented, totalDistance } = processGroupedSegments(groupedSegments, this.props.displayMetric);
    this.drawElevationGraph(pointByPointSegmented, colorsSegmented, totalDistance);
  },
  requestElevationData(encodedPolylines, color) {
    if (this.elevationReq) {
      this.elevationReq.abort();
      this.elevationReq = null;
    }
    const elevationReq = requestElevations(encodedPolylines);
    elevationReq.then(elevations => {
      this.elevationReq = null;
      const { totalDistance, pointByPointSegmented, elevationGain } = processElevations(elevations, this.props.displayMetric);
      this.drawElevationGraph(pointByPointSegmented, [color], totalDistance);
      if (this.props.handleElevationGainChanged) {
        this.props.handleElevationGainChanged(elevationGain);
      }
      return elevations;
    });
    this.elevationReq = elevationReq;
    return elevationReq;
  },
  render() {
    if (this.props.containerDivOverride) {
      return null;
    }
    let className = 'unselectable';
    if (this.props.collapsed) {
      className += ' collapsed';
    }
    return (
      <div key="elevBox" id="elevation-box" className={className}>
        <div id="elevation-collapse-handle" onClick={this.props.collapseHandleClick} />
        <div id="elevation-chart" ref="elevChart" />
      </div>
    );
  }
});

FullscreenMapElevationPane.defaultProps = {
  collapsed: false,
  elevationConfig: {},
  showStatsGroup: true
};

export { FullscreenMapElevationPane };
